export const common = {
  site_name: '安斋拉拉主题站',
  site_subtitle: '官方主题落地页',
  nav_home: '首页',
  nav_works: '作品集',
  nav_articles: '文章资讯',
  nav_about: '关于我们',
  nav_community: '粉丝社区',
  read_more: '阅读更多',
  view_all: '查看全部',
  latest_news: '最新动态',
  popular_works: '热门作品',
  categories: '分类导航',
  faq: '常见问题',
  contact_us: '联系我们',
  breadcrumb_home: '首页',
  scroll_top: '回到顶部',
  search: '搜索',
  no_results: '暂无内容',
  loading: '加载中...',
  back: '返回',
  share: '分享',
};